import type { ResponsiveImageVariantView } from "@slfinrtl/ui-bff-routes"

export const splitByMimeType = (variants: ResponsiveImageVariantView[]) => {
	const jpeg = variants
		.filter((variant) => !variant.mimeType || variant.mimeType === "image/jpeg")
		.sort((variantA: any, variantB: any) => variantA.width - variantB.width)

	const webp = variants
		.filter((variant) => variant.mimeType === "image/webp")
		.sort((variantA: any, variantB: any) => variantA.width - variantB.width)

	return { jpeg, webp }
}
